@let _message = message();

<div
	class="ada-chat-bubble"
	[class.ada-is-active]="isActive()"
	(mouseenter)="isMenuVisible.set(true)"
	(mouseleave)="isMenuVisible.set(false)"
>
	@if (_message.message | adaMarkdown; as _html) {
		<div
			class="ada-chat-bubble-message"
			[innerHTML]="_html"
		></div>
		<ng-content />
	} @else {
		<ada-spinner
			size="small"
			[inheritColor]="true"
		/>
	}

	<div
		ada-color="isQuery() ? 'foreground' : 'onPrimary"
		[class.ada-text-align-right]="isQuery()"
	>
		<ng-container *ngTemplateOutlet="timestampTemplate()" />
	</div>
</div>
<div
	class="ada-chat-bubble-menu"
	[class.ada-hover]="isMenuVisible()"
	(mouseenter)="isMenuVisible.set(true)"
	(mouseleave)="isMenuVisible.set(false)"
>
	<ng-container *ngTemplateOutlet="menuTemplate()" />
</div>
